module.exports = __webpack_public_path__ + "static/media/Bariol-Regular.57ccddc0.woff";